import React from 'react';
import PropTypes from 'prop-types';
import EnteredIntoPrizeDraw from './Entered';
import NotEnteredIntoPrizeDraw from './NotEntered';

const PrizeDraw = ({ eventName, didEntryWin, prize }) => (
    <>
        {didEntryWin ? (
            <EnteredIntoPrizeDraw eventName={eventName} prize={prize} />
        ) : (
            <NotEnteredIntoPrizeDraw eventName={eventName} />
        )}
    </>
);

PrizeDraw.propTypes = {
    eventName: PropTypes.string.isRequired,
    didEntryWin: PropTypes.bool.isRequired,
    prize: PropTypes.string.isRequired
};

export default PrizeDraw;
